// @i18n-ignore-file
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable i18next/no-literal-string */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { ENABLE_I18N } from '@src/config/env'
import { TAbsoluteLocale, TAllLocale } from '@src/config/i18n.config'
import { GatsbyImage } from '@src/types/image-data.type'
import { parseLocale, TRegionDetail } from '@src/utils/i18n.utils'

export interface GetSeoMetapageDataProps {
  slug?: string
  imageUrl?: string
  metaImage?: GatsbyImage
  seoTitle?: string
  seoDescription?: string
  noindex?: boolean
  nofollow?: boolean
  title?: string
  description?: string
  canonicalUrl?: string
}

export interface SeoMetadata {
  title: string | null
  description: string | null
  robots: string
  alternates: {
    canonical: string
    languages: {
      'en-us': string
    }
  }
  openGraph: {
    title: string | null
    description: string | null
    images: { url: string }[] | null
    url: string
  }
}

export const getDefaultLanguageAdjustedLocale = (
  locale: TAbsoluteLocale,
  regionDetails?: TRegionDetail,
): TAllLocale => {
  const { country } = parseLocale(locale)
  const defaultLanguageIsoCodeForCountry = regionDetails?.regions[country]?.defaultLanguageIsoCode

  if (defaultLanguageIsoCodeForCountry === locale) {
    return country
  }
  return locale
}

const getCanonicalPageUrlWithLocale = (
  locale?: TAbsoluteLocale,
  slugWithoutLeadingSlash?: string,
  regionDetails?: TRegionDetail,
) => {
  // Return same as pageUrl if i18n is disabled or if locale is en-us
  if (!locale || locale === 'en-us' || !ENABLE_I18N) {
    return `https://www.quince.com/${slugWithoutLeadingSlash}`
  }
  const defaultLanguageAdjustedLocale = getDefaultLanguageAdjustedLocale(locale, regionDetails)
  return `https://www.quince.com/${defaultLanguageAdjustedLocale}/${slugWithoutLeadingSlash}`
}

export const getSeoMetapageData = (
  seoData?: GetSeoMetapageDataProps | null | undefined,
  locale?: TAbsoluteLocale,
  regionDetails?: TRegionDetail,
): SeoMetadata | null => {
  if (!seoData) return null
  const slugWithoutLeadingSlash = seoData.slug?.startsWith('/') ? seoData.slug.substring(1) : seoData.slug
  const pageUrl = `https://www.quince.com/${slugWithoutLeadingSlash}`
  const canonicalUrl = getCanonicalPageUrlWithLocale(locale, slugWithoutLeadingSlash, regionDetails)

  const index = seoData.noindex === true ? 'noindex' : 'index'
  const follow = seoData.nofollow === true ? 'nofollow' : 'follow'
  const title = seoData.seoTitle || seoData.title || null
  const description = seoData.seoDescription || seoData.description || null
  const seoImage = seoData.imageUrl || seoData.metaImage?.file.url

  return {
    title,
    description,
    robots: `${index}, ${follow}`,
    alternates: {
      canonical: seoData.canonicalUrl || canonicalUrl,
      languages: {
        ['en-us']: pageUrl,
      },
    },
    openGraph: {
      title,
      description,
      images: seoImage ? [{ url: seoImage }] : null,
      url: pageUrl,
    },
  }
}
